// Product Template 4 JavaScript

(function($) {
  'use strict';

  // Initialize the product template 4 functionality
  function initProductTemplate4() {
    // Remove lazyload classes from product detail images to prevent lazy loading
    $('.product_layout_4 img.lazyload').each(function() {
      // Get the data-src attribute
      var imgSrc = $(this).attr('data-src');
      if (imgSrc) {
        // Set the src attribute and remove lazyload class
        $(this).attr('src', imgSrc);
        $(this).removeClass('lazyload');
      }
    });
    // Handle thumbnail click - open gallery modal instead of changing main image
    $('.product_layout_4 .product-thumbnail-item').on('click', function() {
      // Open the gallery modal
      $('#image_gallery').modal('show');

      // Optionally, you can still update the main image if needed
      const imageId = $(this).data('thumbnail-id');
      showMainImage(imageId);
    });

    // Open gallery modal when clicking on main image
    $('.product_layout_4 [data-gallery-open]').on('click', function() {
      $('#image_gallery').modal('show');
    });

    // Open fullscreen modal when clicking on gallery image
    $('#image_gallery [data-fullscreen]').on('click', function() {
      const imageSrc = $(this).attr('src');
      const $fullscreenImage = $('#image_fullscreen .fullscreen-image');

      // Set the image source
      $fullscreenImage.attr('src', imageSrc);
      $fullscreenImage.attr('alt', $(this).attr('alt'));

      // Store the current image index
      const $galleryItems = $('#image_gallery .gallery-item');
      const currentIndex = $galleryItems.index($(this).closest('.gallery-item'));
      $fullscreenImage.data('current-index', currentIndex);

      // Show the fullscreen modal
      $('#image_fullscreen').modal('show');

      // Ensure the image is centered and properly sized
      setTimeout(function() {
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();

        // Reset any previous inline styles
        $fullscreenImage.css({
          'max-width': '80%',
          'max-height': '80vh'
        });

        // Force browser to recalculate layout
        $fullscreenImage.hide().show(0);
      }, 100);
    });

    // Handle fullscreen navigation
    $('#image_fullscreen .fullscreen-prev').on('click', function() {
      navigateFullscreen('prev');
    });

    $('#image_fullscreen .fullscreen-next').on('click', function() {
      navigateFullscreen('next');
    });

    // Add keyboard navigation for fullscreen modal
    $(document).on('keydown', function(e) {
      if ($('#image_fullscreen').hasClass('in')) {
        if (e.keyCode === 37) { // Left arrow
          navigateFullscreen('prev');
        } else if (e.keyCode === 39) { // Right arrow
          navigateFullscreen('next');
        } else if (e.keyCode === 27) { // Escape key
          $('#image_fullscreen').modal('hide');
        }
      }
    });

    // Handle tab navigation
    $('.product_layout_4 .tab').on('click', function() {
      const tabId = $(this).data('tab');

      // Update active tab
      $('.product_layout_4 .tab').removeClass('active');
      $(this).addClass('active');

      // Show the corresponding tab content
      $('.product_layout_4 .tab-panel').removeClass('active');
      $('#' + tabId).addClass('active');
    });

    // Handle Questions button click
    $('.product_layout_4 .interaction-button[data-target="#ask_an_expert"]').on('click', function() {
      $('#ask_an_expert').modal('show');
    });

    // Handle Share button click
    $('.product_layout_4 .interaction-button[data-target="#share_modal"]').on('click', function() {
      $('#share_modal').modal('show');

      // Ensure copy button is initialized after modal is shown
      $('#share_modal').on('shown.bs.modal', function() {
        if (typeof initCopyToClipboard === 'function') {
          initCopyToClipboard();
        }
      });
    });

    // Handle Save button click (wishlist functionality)
    $('.product_layout_4 .save-product').on('click', function() {
      const productId = $(this).data('product-id');

      // Get existing wishlist from localStorage
      let wishlist = JSON.parse(localStorage.getItem('jdm_wishlist') || '[]');

      // Check if product is already in wishlist
      const productIndex = wishlist.indexOf(productId);

      if (productIndex === -1) {
        // Add to wishlist
        wishlist.push(productId);
        $(this).addClass('saved');

        // Show toast notification
        showToast('Product saved to wishlist!');
      } else {
        // Remove from wishlist
        wishlist.splice(productIndex, 1);
        $(this).removeClass('saved');

        // Show toast notification
        showToast('Product removed from wishlist');
      }

      // Save updated wishlist
      localStorage.setItem('jdm_wishlist', JSON.stringify(wishlist));
    });

    // Check if product is in wishlist and update UI
    const productId = $('.product_layout_4 .save-product').data('product-id');
    if (productId) {
      const wishlist = JSON.parse(localStorage.getItem('jdm_wishlist') || '[]');
      if (wishlist.indexOf(productId) !== -1) {
        $('.product_layout_4 .save-product').addClass('saved');
      }
    }

    // Function to show toast notification
    function showToast(message) {
      // Create toast if it doesn't exist
      if ($('#toast-notification').length === 0) {
        $('body').append('<div id="toast-notification" style="position: fixed; bottom: 20px; right: 20px; background-color: #333; color: white; padding: 12px 20px; border-radius: 4px; z-index: 9999; opacity: 0; transition: opacity 0.3s ease;"></div>');
      }

      // Set message and show toast
      $('#toast-notification').text(message).css('opacity', '1');

      // Hide toast after 3 seconds
      setTimeout(function() {
        $('#toast-notification').css('opacity', '0');
      }, 3000);
    }
  }

  // Show the main image with the given ID
  function showMainImage(imageId) {
    // Get all product media
    const $productMedia = $('.product_layout_4 .product-single__photo');

    // Find the media with the matching ID
    const $targetMedia = $productMedia.filter(function() {
      return $(this).data('image-id') === imageId;
    });

    // If found, update the main image
    if ($targetMedia.length) {
      const $mainImageContainer = $('.product_layout_4 .product-main-image');
      const $currentImage = $mainImageContainer.find('.product-single__photo-wrapper');

      // Replace the current image with the target image
      $currentImage.replaceWith($targetMedia.closest('.product-single__photo-wrapper').clone());

      // Reinitialize zoom if enabled
      if (typeof window._enableZoom === 'function') {
        window._enableZoom($mainImageContainer.find('.js-zoom-enabled'));
      }
    }
  }

  // Navigate through images in fullscreen mode
  function navigateFullscreen(direction) {
    const $galleryItems = $('#image_gallery .gallery-item');
    const $fullscreenImage = $('#image_fullscreen .fullscreen-image');
    let currentIndex = $fullscreenImage.data('current-index');

    if (direction === 'prev') {
      currentIndex = (currentIndex - 1 + $galleryItems.length) % $galleryItems.length;
    } else {
      currentIndex = (currentIndex + 1) % $galleryItems.length;
    }

    // Update the fullscreen image
    const $newImage = $($galleryItems[currentIndex]).find('[data-fullscreen]');
    const newImageSrc = $newImage.attr('src');
    const newImageAlt = $newImage.attr('alt');

    // Fade out current image, update src, then fade in
    $fullscreenImage.fadeOut(150, function() {
      $fullscreenImage.attr('src', newImageSrc);
      $fullscreenImage.attr('alt', newImageAlt);
      $fullscreenImage.data('current-index', currentIndex);

      // Reset any inline styles to ensure proper centering
      $fullscreenImage.css({
        'max-width': '80%',
        'max-height': '80vh'
      });

      $fullscreenImage.fadeIn(150);
    });
  }

  // Initialize when the document is ready
  $(document).ready(function() {
    initProductTemplate4();
  });

  // Reinitialize when the section is reloaded
  $(document).on('shopify:section:load', function(event) {
    if ($(event.target).find('.product_layout_4').length) {
      initProductTemplate4();
    }
  });

})(jQuery);
